import React from 'react';
import { JobActions } from './JobActions';
import { formatSalary } from '../../lib/salary';

// Back nav + title/subtitle + action buttons for the Job Detail page.
export function JobHeader({ job, candidatesCount, navigate, actions }) {
  const salary = formatSalary(job);
  return (
    <div className="page-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <button onClick={() => navigate('/jobs')} style={{ background: 'none', border: 'none', color: 'hsl(var(--muted-foreground))', cursor: 'pointer', padding: '0.25rem' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <div>
          <h1 className="page-title">{job.title}</h1>
          <p className="page-subtitle">
            {job.location || 'Remote'} &middot; {job.job_type} &middot; {candidatesCount} candidates
            {salary && <span data-testid="job-detail-salary" style={{ marginLeft: 8, display: 'inline-flex', alignItems: 'center', padding: '0.0625rem 0.5rem', borderRadius: 999, background: '#CCFBF1', color: '#0F766E', fontWeight: 700, fontSize: '0.75rem' }}>{salary}</span>}
          </p>
        </div>
      </div>
      <JobActions {...actions} />
    </div>
  );
}
